import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { ActionType } from '@submissions/submissions.reducer'
import { ApiResponseTemplate } from '@templates/types'
import { useTemplateQuery } from './queries/useTemplateQuery'

interface Args {
  templateId: string
}

interface IDispatchItem {
  type: ActionType
  payload: ApiResponseTemplate[]
}

/**
 * Use the template found by ID from the redux store;
 * if the template is not found, fetch and add it to the store.
 * @param Args
 * @param {string} Args.templateId The template ID to find the template.
 * @returns The template object.
 */
export const useTemplate = ({ templateId }: Args) => {
  const dispatch = useDispatch()
  const { data: template } = useTemplateQuery({
    id: templateId,
    options: {
      enabled: !!templateId,
      refetchOnWindowFocus: false,
      select: data => {
        const updatedTemplate = Object.entries(data).reduce((memo, [key, value]) => {
          if (key !== 'rollupDatasetId') return { ...memo, [key]: value }

          memo.rollup_dataset_id = +value

          return memo
        }, {} as ApiResponseTemplate)

        return updatedTemplate
      },
    },
  })

  useEffect(() => {
    if (template?.id) {
      const dispatchItem: IDispatchItem = {
        type: ActionType.TEMPLATES_LOADED,
        payload: [template],
      }

      dispatch(dispatchItem)
    }
  }, [template?.id])

  return {
    template,
  }
}
